// lib/csv.ts — Excel-совместимый CSV-экспорт (R22): BOM + разделитель «;» + RFC-экранирование,
// скачивание через Blob + anchor (без сторонних зависимостей).

/** Значение CSV-ячейки: строка/число, null/undefined → пустое поле. */
export type CsvCell = string | number | null | undefined;

/** Строка CSV-таблицы. */
export type CsvRow = CsvCell[];

/** BOM UTF-8 — первый символ файла, чтобы Excel корректно распознал кириллицу. */
const BOM = '\uFEFF';

/** Разделитель полей для Excel-совместимости (ru-локаль). */
const FIELD_SEPARATOR = ';';

/** Символы, требующие обёртки поля в кавычки. */
const QUOTE_REQUIRED_PATTERN = /[;"\n\r]/;

/** Экранирует значение ячейки: кавычки удваиваются, поле с «;»/«"»/переводом строки оборачивается. */
function escapeCell(cell: CsvCell): string {
  if (cell === null || cell === undefined) return '';
  const text = String(cell);
  if (!QUOTE_REQUIRED_PATTERN.test(text)) return text;
  return `"${text.replace(/"/g, '""')}"`;
}

/**
 * Собирает CSV-строку: BOM + заголовки + строки данных.
 * Разделитель полей «;», разделитель строк CRLF (Excel-friendly).
 */
export function toCsv(rows: CsvRow[], headers: string[]): string {
  const lines = [headers, ...rows].map((row) => row.map(escapeCell).join(FIELD_SEPARATOR));
  return BOM + lines.join('\r\n');
}

/**
 * Инициирует скачивание CSV-файла в браузере: Blob text/csv;charset=utf-8,
 * временный object URL, клик по скрытому anchor, отзыв URL.
 */
export function downloadCsv(filename: string, csv: string): void {
  const blob = new Blob([csv], { type: 'text/csv;charset=utf-8' });
  const url = URL.createObjectURL(blob);
  const anchor = document.createElement('a');
  anchor.href = url;
  anchor.download = filename;
  document.body.appendChild(anchor);
  anchor.click();
  document.body.removeChild(anchor);
  URL.revokeObjectURL(url);
}
